// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__eA01X","badge-dot":"style_badge-dot__n3Lzm","badgeDot":"style_badge-dot__n3Lzm"};